import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

// servicos
import api from 'services/api';
import { Status, Tipo } from '../../utils/variables';

// actions
import { show } from 'store/modules/dialog/actions';

// componentes
import Button from 'components/Button';
import Card from 'components/Card';
import Pagination from 'components/Pagination';
import Input from 'components/Input';
import Flag from 'components/Flag';
import PlayerBaixa from 'components/PlayerBaixa';
import DropDownMenu from 'components/DropDownMenu';
import Loader from 'components/ContentLoader/GenericLoader';

// estilos
import {
  Container,
  Lista,
  Item,
  Dados,
  Steps,
  Step,
  Alert,
  Acoes,
  Form,
} from './styles';
import { Scroll } from 'styles/global';

// icons
import {
  FiSearch,
  FiPlus,
  FiXCircle,
  FiClock,
  FiBox,
  FiCheckCircle,
  FiAlertTriangle,
  FiPlay,
  FiChevronRight,
  FiUnlock,
  FiEdit,
  FiTrash2,
  FiTv,
} from 'react-icons/fi';
import Tooltip from 'components/Tooltip';
import { Chamada, ChamadaEmissora, Patrocinio } from 'pages/@types';
import Checkbox from 'components/Checkbox';

interface IStep {
  key: number;
  step: number;
  flag: string;
  titulo: string;
  status: {
    flag: 'finish' | 'wait' | 'error' | 'process';
    mensagem: string;
  };
}

export interface IStepPromo {
  curstate: number;
  steps: IStep[];
}
interface IPromo extends Chamada {
  previa: boolean;
  state: IStepPromo;
}

export default function Promo() {
  // react-router-dom
  const navigate = useNavigate();
  /**
   * VARIAVEIS
   */
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState({} as IPromo);
  const [promos, setPromos] = useState<IPromo[]>([]);
  const [pages, setPages] = useState(1);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [previa, setPrevia] = useState(false);
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });

  /**
   * REDUX
   */
  const dispatch = useDispatch();
  const { callback: callbackDialog } = useSelector(
    (state: any) => state.dialog,
  );

  /**
   * USE CALLBACK
   */
  // const handleNovoPromo = useCallback(() => {
  //   navigate('/chamadas/novo');
  // }, []);

  // const handleKanban = useCallback(chamadaId => {
  //   navigate(`/chamadas/${chamadaId}/kanban`);
  // }, []);

  // const handleEdit = useCallback(chamadaId => {
  //   navigate(`/chamadas/${chamadaId}`);
  // }, []);

  const handlePlayer = useCallback(
    midia => {
      if (!!midia && midia.preview_url) {
        setPlayer({
          open: !player.open,
          midia_url: midia.preview_url,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );

  // fecha player
  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);

  const patrocinios = useCallback(
    lista =>
      lista.length > 0 ? (
        lista.map((entrada: Patrocinio, index: number) => (
          <Flag
            key={index}
            type={entrada.comercial?.statusdownload || 'indisponivel'}
            name={entrada.codmaterial.toString()}
            tooltip={entrada.descricao}
            handleAction={() => handlePlayer(entrada.comercial?.midia)}
            icon={<FiPlay />}
          />
        ))
      ) : (
        <Flag type="indisponivel" name="NÃO INFORMADO" />
      ),
    [handlePlayer],
  );

  const formatDestino = useCallback((emissora: ChamadaEmissora[]) => {
    return emissora.length === 8
      ? 'REDE'
      : emissora.map(emi => emi.emissora.sigla).join(', ');
  }, []);

  const handleLiberarProducao = useCallback(
    promo => {
      setSelected(promo);
      const optionBase = {
        type: 'question',
        contentHTML: `Liberar a produção de <b>${promo.retranca}</b> ?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: `/promos/${promo.id}`,
          method: api.patch,
          action: 'liberaprod',
        },
        haveCallback: true,
        successMessage: 'Produção liberada!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };
      dispatch(show(optionBase));
    },
    [dispatch],
  );

  const handleDelete = useCallback(
    promo => {
      setSelected(promo);
      const optionBase = {
        type: 'question',
        contentHTML: `Remover <b>${promo.retranca}</b> ?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: `/chamadas/${promo.id}`,
          method: api.delete,
        },
        haveCallback: true,
        successMessage: 'Promo removida!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };
      dispatch(show(optionBase));
    },
    [dispatch],
  );

  const handleActionSelect = useCallback(
    (promo, action) => {
      switch (action.value) {
        case 2:
          handleDelete(promo);
          break;
      }
    },
    [handleDelete],
  );
  /**
   * USEEFFECT
   */
  useEffect(() => {
    const controller = new AbortController();
    async function buscaPromos() {
      try {
        setLoading(true);
        const response = await api.get(`/promos/`, {
          signal: controller.signal,
          params: {
            page,
            ...(search && { search }),
            ...(previa && { previa: true }),
          },
        });
        if (response && response.data) {
          setPromos(response.data.promos);
          setPages(response.data.pages);
        }
      } catch (err) {
        if (err instanceof Error) toast.error(err.message);
        else toast.error('Erro inesperado');
      } finally {
        setLoading(false);
      }
    }
    buscaPromos();
    return () => {
      controller.abort();
    };
  }, [search, page, previa]);

  useEffect(() => {
    if (callbackDialog && callbackDialog.success) {
      if (callbackDialog.success.action === 'liberaprod' && selected) {
        // Atualiza tabela removendo o promo deletado
        setPromos(prevState =>
          prevState.map(p => {
            console.log(p);
            return p.id === selected.id
              ? {
                  ...p,
                  previa: false,
                  state: {
                    curstate: 2,
                    steps: [
                      ...p.state.steps.slice(0, 1),
                      {
                        key: p.id * 10 + 2,
                        step: 2,
                        flag: 'liberacao',
                        titulo: 'Liberação',
                        status: {
                          flag: 'finish',
                          mensagem: `Material liberado para produção`,
                        },
                      },
                      ...p.state.steps.slice(2),
                    ],
                  },
                }
              : p;
          }),
        );
      }
      if (callbackDialog.success.action === 'success' && selected) {
        // Atualiza tabela removendo o promo deletado
        setPromos(prevState => prevState.filter(s => s.id !== selected.id));
      }
    }
  }, [callbackDialog, selected]);

  return (
    <Container>
      <header>
        <Button href={`/chamadas/novo`} color="primary">
          NOVO PROMO <FiPlus />
        </Button>
      </header>
      <Card>
        <>
          <header>
            <h4>LISTA DE PROMOS</h4>
            <Pagination
              total={pages}
              activePage={page}
              onClick={page => setPage(page)}
            />
            <div>
              <Form
                onSubmit={e => {
                  setPage(1);
                  setSearch(e.searchLocal);
                }}
              >
                <Checkbox
                  name="tipo"
                  options={[{ id: 'previas', label: 'SOMENTE PRÉVIAS' }]}
                  handleSelected={value => setPrevia(value.checked)}
                  disabled={loading}
                />
                <Input
                  name="searchLocal"
                  placeholder="Buscar na Tabela"
                  icon={<FiSearch />}
                  disabled={loading}
                />
              </Form>
            </div>
          </header>
          <Scroll>
            {loading ? (
              <Loader />
            ) : !promos ? (
              <p>Nenhum comercial encontrado</p>
            ) : (
              <Lista>
                {promos.map((promo, index) => (
                  <Item key={index}>
                    <Dados>
                      <span>
                        <p>TITULO</p>
                        <strong>{promo.retranca}</strong>
                      </span>
                      <span>
                        <p>PATROCÍNIOS</p>
                        {patrocinios(promo.patrocinios)}
                      </span>
                      <span>
                        <p>DURACAO</p>
                        <strong>{promo.duracao}</strong>
                      </span>
                      <span>
                        <p>COD MATERIAL</p>
                        {promo.codmaterial ? (
                          <strong>{promo.codmaterial}</strong>
                        ) : (
                          <>
                            <Alert id={`id_alert_cm_${index}`}>
                              <FiAlertTriangle />
                            </Alert>
                            <Tooltip target={`id_alert_cm_${index}`}>
                              DEFINIR CM
                            </Tooltip>
                          </>
                        )}
                      </span>
                      <span>
                        <p>DESTINO</p>
                        <strong>{formatDestino(promo.chamadaemissora)}</strong>
                      </span>
                    </Dados>

                    <Steps
                      key={promo.id}
                      labelPlacement="vertical"
                      current={promo.state.curstate}
                      icons={{
                        finish: <FiCheckCircle />,
                        error: <FiXCircle />,
                      }}
                    >
                      {promo.state.steps.map((step, indexStep) => (
                        <React.Fragment
                          key={`${step.key}fragment${promo.id}_${indexStep}`}
                        >
                          <Step
                            key={`${step.key}_STEP${promo.id}_${indexStep}`}
                            id={`tooltip_steep_${step.key}_${indexStep}`}
                            title={step.titulo}
                            stepIndex={indexStep}
                            status={
                              step.step === promo.state.curstate + 1
                                ? step.status.flag === 'error'
                                  ? 'error'
                                  : 'process'
                                : step.status.flag
                            }
                            next={
                              promo.state.steps[indexStep + 1]
                                ? promo.state.steps[indexStep + 1].status.flag
                                : 'wait'
                            }
                            icon={
                              step.status.flag === 'wait' ? (
                                step.step === promo.state.curstate + 1 ? (
                                  <FiBox /> // etapa atual
                                ) : (
                                  <FiClock />
                                )
                              ) : step.status.flag === 'error' ? (
                                <FiXCircle />
                              ) : (
                                <FiCheckCircle />
                              )
                            }
                          />
                          <Tooltip
                            key={`${step.key}tooltip${promo.id}_${indexStep}`}
                            target={`tooltip_steep_${step.key}_${indexStep}`}
                          >
                            {step.status.mensagem}
                          </Tooltip>
                        </React.Fragment>
                      ))}
                    </Steps>

                    <Acoes>
                      <p>AÇÕES</p>
                      <Button
                        id={`id_viewch_${index}`}
                        fill
                        color="font"
                        round
                        href={`/chamadas/${promo.id}/kanban`}
                      >
                        <FiChevronRight />
                      </Button>
                      <Tooltip target={`id_viewch_${index}`}>
                        IR PARA KANBAN
                      </Tooltip>
                      {promo.previa ? (
                        <>
                          <Button
                            id={`id_liberar_${index}`}
                            fill
                            color="font"
                            round
                            onClick={() => handleLiberarProducao(promo)}
                            disabled={!promo.previa}
                          >
                            <FiUnlock />
                          </Button>
                          <Tooltip
                            target={`id_liberar_${index}`}
                            position="left"
                          >
                            LIBERAR PRODUÇÃO
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          <Button
                            id={`id_preview_${index}`}
                            fill
                            color="font"
                            round
                            onClick={() => handlePlayer(promo.midia)}
                            disabled={!promo.midia}
                          >
                            <FiTv />
                          </Button>
                          <Tooltip
                            target={`id_preview_${index}`}
                            position="left"
                          >
                            ASSISTIR
                          </Tooltip>
                        </>
                      )}
                      <DropDownMenu
                        disabled={false}
                        id={`acoes${index}`}
                        actions={[
                          {
                            value: 0,
                            label: 'EDITAR',
                            disabled: !!(
                              [
                                Status.APROVADO,
                                Status.ENTREGUE,
                                Status.FINALIZADO,
                              ].includes(promo.status) ||
                              (promo.tipo === Tipo.VINHETA && promo.midia)
                            ),
                            icon: <FiEdit />,
                            href: `/chamadas/${promo.id}`,
                          },
                          {
                            value: 2,
                            label: 'APAGAR',
                            disabled: !!promo.midia,
                            icon: <FiTrash2 />,
                          },
                        ]}
                        handleClick={action =>
                          !action.disabled && handleActionSelect(promo, action)
                        }
                      />
                    </Acoes>
                  </Item>
                ))}
              </Lista>
            )}
          </Scroll>
        </>
      </Card>

      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Container>
  );
}
